import React, { Component, Fragment } from "react";
import * as HMS from "../../../common/component/Index";
import * as Func from "../../../../../helpers/functions";
import PackageRate from "../../../../../models/PackageRate";
import PackageRateDescription from "../../../../../models/PackageRateDescription";
import PackageRateProduction from "../../../../../models/PackageRateProduction";
import isEqual from "lodash/isEqual";
import {
  DETAIL_ACTIONS,
  PATHS,
  FEATURE_FLAGS,
  DATE_TIME_FORMAT,
} from "../../../../../constants/Define";
import { cloneDeep } from "lodash";
import TranslateButton from "../../../common/component/TranslateButton";
import "./style.less";
import Tabs, { TabPane } from "../../../common/component/Tabs";
import PackageRateInfo from "./tabs/PackageRateInfo";
import PackageRateDesc from "./tabs/PackageRateDesc";
import PackageRateProducts from "./tabs/PackageRateProducts";
import moment from "moment";

export default class PackageRateDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {},
      action: this.props.match.params.id
        ? DETAIL_ACTIONS.UPDATE
        : DETAIL_ACTIONS.CREATE,
      isViewMode: this.props.match.path === PATHS.PACKAGE_RATE.VIEW.path,
      PackageRate: new PackageRate(),
      PackageRateDescription: new PackageRateDescription(),
      PackageRateProduction: new PackageRateProduction(),
      validation: {},
      validationDesc: {
        extraInfos: []
      },
      validationProd: {},
      tab: window.location?.hash?.substring(1) || "info",
    };
  }

  onChange = (field, value) => {
    if (field) {
      const PackageRate = this.state.PackageRate;
      const variables = field.split(".");

      variables.reduce((o, i, index) => {
        if (index === variables.length - 1) {
          o[i] = value;
        }
        return o[i];
      }, PackageRate);

      this.setState({ PackageRate, isSubmit: false });
    }
  };

  onChangeDesc = (field, value) => {
    if (field) {
      const PackageRateDescription = this.state.PackageRateDescription;
      const variables = field.split(".");

      variables.reduce((o, i, index) => {
        if (index === variables.length - 1) {
          o[i] = value;
        }
        return o[i];
      }, PackageRateDescription);

      this.setState({ PackageRateDescription });
    }
  };

  onChangeProd = (field, value) => {
    if (field) {
      const PackageRateProduction = this.state.PackageRateProduction;
      const variables = field.split(".");

      variables.reduce((o, i, index) => {
        if (index === variables.length - 1) {
          o[i] = value;
        }
        return o[i];
      }, PackageRateProduction);

      this.setState({ PackageRateProduction });
    }
  };

  componentDidMount() {
    const { match } = this.props;
    match.params.id && this.props.getPackageRateDetail(match.params.id);
  }

  onShowTranslate = (language) => {
    const { PackageRateDescription } = this.state;
    PackageRateDescription.setTranslate(language.code);
    PackageRateDescription.setData();
    this.setState({ PackageRateDescription, action: DETAIL_ACTIONS.TRANSLATE });
  };

  onExitTranslate = (isUpdateTrans = false) => {
    const PackageRateDescription = cloneDeep(this.state.PackageRateDescription);
    const action = DETAIL_ACTIONS[PackageRateDescription.id ? "UPDATE" : "CREATE"];
    PackageRateDescription.setTranslate(undefined, true);
    PackageRateDescription.setData();
    this.setState({ PackageRateDescription, action });
  };

  onSubmit = async (e) => {
    e.preventDefault();
    const { PackageRate, PackageRateDescription, PackageRateProduction } = this.state;
    switch (this.state.tab) {
      case "info":
        if (this.validate()) {
          if (this.state.action === DETAIL_ACTIONS.UPDATE) {
            this.props.updatePackageRate(PackageRate.export(), PackageRate.id);
          } else {
            this.props.createPackageRate(PackageRate.export());
          }
        }
        break;
      case "detail":
        if (this.validateDesc()) {
          const data = { ...PackageRateDescription.export(), name: PackageRate.name};
          if (!!PackageRateDescription.id) {
            this.props.updatePackageRateTransalte(PackageRate.id, data);
            this.onExitTranslate();
          } else {
            this.props.createPackageRateTransalte(PackageRate.id, data);
          }
        }
        break;
        case "productList":
          if (this.validateProd()) {
            const data = { ...PackageRateProduction.export(), name: PackageRate.name};
            if (!!PackageRateProduction.id) {
              this.props.updatePackageRateProduct(PackageRate.id, data);
            } else {
              this.props.createPackageRateProduct(PackageRate.id, data);
            }
          }
          break;
      default:
        break;
    }
  };

  componentWillReceiveProps(nextProps) {
    //receive data tab 1
    if (nextProps.packageRateState.Detail && !isEqual(nextProps.packageRateState.Detail, this.props.packageRateState.Detail)) {
      this.setState({
        PackageRate: nextProps.packageRateState.Detail,
        loading: false,
        isSubmit: false,
      });
    }

    //receive data tab 2
    if (nextProps.packageRateState.TranslateDetail && !isEqual(nextProps.packageRateState.TranslateDetail, this.props.packageRateState.TranslateDetail)) {
      this.setState({PackageRateDescription: nextProps.packageRateState.TranslateDetail});
    }

    //receive data tab 3
    if (nextProps.packageRateState.ProductDetail && !isEqual(nextProps.packageRateState.ProductDetail, this.props.packageRateState.ProductDetail)
    ) {
      this.setState({PackageRateProduction: nextProps.packageRateState.ProductDetail});
    }

    //default tab
    if (nextProps.packageRateState.tab && !isEqual(nextProps.packageRateState.tab,this.props.packageRateState.tab)) {
      let tab = "";
      switch (nextProps.packageRateState.tab) {
        case 1:
          tab = "info"
          break;
        case 2:
          tab = "detail"
          break;
        case 3:
          tab = "productList"
          break;
        default:
          break;
      }
      this.onChangeTab(tab);
    }
  }

  validate() {
    const { t } = this.props;
    let validate = {
      required: {
        code: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.packageRate.code`)
        ),
        name: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.packageRate.name`)
        ),
        description: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.packageRate.description`)
        )
      },
      minLength: {
        displaySale: Func.formatValidation(t('validation.statusCode.code.1'), t("item.packageRate.displaySale")),
      },
      isCodeWithUnderscore: { code: t('validation.code') },
    };

    if(this.state.PackageRate?.bookingDatesConfig?.dateRanges?.length && this.state.PackageRate?.stayingDatesConfig?.dateRanges?.length){
      const bookingDates = this.state.PackageRate.bookingDatesConfig.dateRanges.map(x=> moment(x.dateRange?.dateFrom, [DATE_TIME_FORMAT.SHORT_DATE_EXPORT, DATE_TIME_FORMAT.SHORT_DATE]));
      const stayingDates = this.state.PackageRate.stayingDatesConfig.dateRanges.map(x=> moment(x.dateRange?.dateFrom, [DATE_TIME_FORMAT.SHORT_DATE_EXPORT, DATE_TIME_FORMAT.SHORT_DATE]));
      const minBookingDate = moment.min(bookingDates);
      const minStayingDate = moment.min(stayingDates);

      if(minBookingDate.isAfter(minStayingDate)){
        validate.isError = { overlapDates: t(`item.packageRate.validateUsingDate`)};
      }
    }

    if(!this.state.PackageRate?.channel?.length){
      validate.isError = { ...(validate.isError || {}), channel: Func.formatValidation(t("validation.statusCode.code.1"), t(`item.packageRate.channel`)) };
    }

    if(!this.state.PackageRate?.objectApplyValue?.length){
      validate.isError = { ...(validate.isError || {}), objectApplyValue: Func.formatValidation(t("validation.statusCode.code.1"), t(`item.packageRate.objectApplyValue`)) };
    }

    let valueValidate = {
      minLength: {
        displaySale: 1
      },
    };
    const result = Func.multipleValidate(
      this.state.PackageRate,
      validate,
      valueValidate
    );

    let validateDateRanges = {
      required: {
        dateFrom: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.packageRate.stageDate`)
        ),
        dateTo: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.packageRate.stageDate`)
        ),
      },
    };

    let validationBookingDateRanges = [];
    const bookingDateRanges = this.state.PackageRate?.bookingDatesConfig?.dateRanges || [];
    bookingDateRanges.forEach((item) => {
      validationBookingDateRanges.push(Func.multipleValidate(item.dateRange || {}, validateDateRanges));
    });

    let validationStayingDateRanges = [];
    const stayingDateRanges = this.state.PackageRate?.stayingDatesConfig?.dateRanges || [];
    stayingDateRanges.forEach((item) => {
      validationStayingDateRanges.push(Func.multipleValidate(item.dateRange || {}, validateDateRanges));
    });

    //result booking
    const bookingDatesConfig = { dateRanges: validationBookingDateRanges };

    //result staying
    if(!validationStayingDateRanges.filter(x=>Object.keys(x).length).length && result.overlapDates){
      validationStayingDateRanges = [{dateFrom: result.overlapDates}];
    }

    const stayingDatesConfig = { dateRanges: validationStayingDateRanges };


    this.setState({ validation: { ...result, bookingDatesConfig, stayingDatesConfig }});
    return Object.keys(result).length < 1 && validationBookingDateRanges.filter(x=>Object.keys(x).length) < 1 && validationStayingDateRanges.filter(x=>Object.keys(x).length) < 1;
  }

  validateDesc() {
    const { t } = this.props;
    let validate = {
      required: {
        title: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.packageRate.titleDesc`)
        ),
        languageCode: Func.formatValidation(
          t("validation.statusCode.code.1"),
          t(`item.packageRate.titleDesc`)
        ),
      },
    };

    if (this.state.action === DETAIL_ACTIONS.CREATE) {
      validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
    }

    let validateExtraInfos = {
      required: {
          title: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.packageRate.titleContent`)),
          content: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.packageRate.content`))
      },
      maxLength: { title: Func.formatValidation(t('validation.statusCode.code.4'), 50) },
    };

    let valueValidate = {};
    const result = Func.multipleValidate(
      this.state.PackageRateDescription,
      validate,
      valueValidate
    );

    let validationExtraInfos = [];
    this.state.PackageRateDescription.extraInfos.forEach((item) => {
      validationExtraInfos.push(Func.multipleValidate(item, validateExtraInfos));
    });

    this.setState({ validationDesc: { ...result, extraInfos: validationExtraInfos } });
    return Object.keys(result).length < 1 && validationExtraInfos.filter(x=> Object.keys(x).length).length < 1;
  }

  validateProd() {
    const { t } = this.props;
    let validate = {
      required: {
        hotelId: t("item.packageRate.selectHotelPlaceholder"),
        
      },
      minLength: {
        roomTypeIds: Func.formatValidation(t('validation.statusCode.code.1'), t("item.packageRate.selectRoomType")),
      }
    };

    let valueValidate = {
      minLength: {
        roomTypeIds: 1
      },
    };
    const result = Func.multipleValidate(
      this.state.PackageRateProduction,
      validate,
      valueValidate
    );

    let validateRatePlan = {
      required: {
        ratePlanId: t("item.packageRate.selectRatePlaceholder"),
      }
    };

    const resultRate = Func.multipleValidate(
      this.state.PackageRateProduction?.ratePlan || {},
      validateRatePlan,
      {}
    );

    // let validateList = {
    //   required: {
    //     markupType: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.packageRate.markupType`)),
    //     markupValue: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.packageRate.markupValue`)),
    //   }
    // };

    // const resultList = [];
    // const dataList = this.state.PackageRateProduction.getList() || [];
    // dataList.forEach((item) => {
    //   // convert data to validate value = 0
    //   const row = {...item, markupType: item.markupType == 0 ? 10 : item.markupType};
    //   resultList.push(Func.multipleValidate(row, validateList));
    // });

    // this.setState({ validationProd: { ...result, ratePlan: resultRate, resultList } });
    // return Object.keys(result).length < 1 && Object.keys(resultRate).length < 1 && resultList.filter(x=> Object.keys(x).length > 0).length < 1;

    this.setState({ validationProd: { ...result, ratePlan: resultRate } });
    return Object.keys(result).length < 1 && Object.keys(resultRate).length < 1;
  }

  onClickBack = () => {
    if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
      this.onExitTranslate();
    } else {
      const path = PATHS.PACKAGE_RATE.LIST.path
      this.props.history.push(path);
      this.props.resetPackageRateDetail();
    }
  };

  onChangeTab = (key) => {
    this.setState({ tab: key });
  };

  render() {
    const { t, match, hotelState, bookablePackageRateState, rateState, packageRateState, roomTypeState } = this.props;
    const { action, PackageRate, PackageRateDescription, PackageRateProduction, isSubmit, validation, validationDesc, validationProd, tab } = this.state;
    return (
      <Fragment>
        <HMS.LoadingComponent spinning={packageRateState?.isFetching || packageRateState?.isUpdating || bookablePackageRateState?.isFetching || rateState?.isFetching}>
          <HMS.PageListComponent className="PackageRate-detail">
            <HMS.HeaderListComponent
              path={match.path}
              groupPath={"package-rates"}
              titleHeader={
                Func.capitalizeFirstLetter(
                `${t(
                  this.state.isViewMode ? "action.show" : 
                  (action === DETAIL_ACTIONS.CREATE
                    ? "action.create"
                    : "action.update")
                )} ${t("item.packageRate.title")}`.toLowerCase()
              )}
              componentRight={
                FEATURE_FLAGS.TRANSLATE_ENABLE &&
                this.state.tab === "detail" && (
                  <TranslateButton
                    languages={PackageRateDescription.translations}
                    current={PackageRateDescription.languageCode}
                    validation={validationDesc.languageCode}
                    onChange={this.onShowTranslate}
                    onClear={this.onExitTranslate}
                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                    onSelectDefault={(language) =>
                      this.onChangeDesc("languageCode", language.code)
                    }
                    disabledActionRemove
                  />
                )
              }
            />

            <HMS.FormActionComponent
              onSubmit={this.onSubmit}
              isSubmit={isSubmit}
              action={action}
              isGetItem={false}
              onClickBack={this.onClickBack}
              backButtonText={
                action === DETAIL_ACTIONS.TRANSLATE
                  ? t(`action.cancel`)
                  : t(`action.back`)
              }
              titleButtonSubmit={t(`action.save`)}
              activeComponent={false}
              submitButtonRight={true}
              disableButtonSubmit={this.state.isViewMode}
            >
              <Tabs
                activeKey={tab}
                onChange={this.onChangeTab}
                className="w-100"
              >
                <TabPane
                  tab={t("item.packageRate.generalInformation")}
                  key="info"
                >
                  <PackageRateInfo
                    {...this.props}
                    PackageRate={PackageRate}
                    validation={validation}
                    action={action}
                    onChange={this.onChange}
                    disabled={this.state.isViewMode}
                  />
                </TabPane>
                <TabPane
                  tab={t("item.packageRate.detailDescription")}
                  key="detail"
                  disabled={action === DETAIL_ACTIONS.CREATE}
                >
                  <PackageRateDesc
                    {...this.props}
                    PackageRate={PackageRateDescription}
                    validation={validationDesc}
                    action={action}
                    onChange={this.onChangeDesc}
                    disabled={this.state.isViewMode}
                  />
                </TabPane>
                <TabPane
                  tab={t("item.packageRate.productList")}
                  key="productList"
                  disabled={action === DETAIL_ACTIONS.CREATE}
                >
                  <PackageRateProducts
                    t={this.props.t}
                    match={this.props.match}
                    PackageRateProduction={PackageRateProduction || {}}
                    hotels={hotelState?.allHotels || []}
                    bookablePackageRates={bookablePackageRateState?.allList || []}
                    rates={rateState?.dataList || []}
                    validation={validationProd}
                    action={action}
                    onChange={this.onChangeProd}
                    getAllHotels={this.props.getAllHotels}
                    getListRates={this.props.getListRates}
                    getListAllBookablePackageRates={this.props.getListAllBookablePackageRates}
                    getRateCodeListAll={this.props.getRateCodeListAll}
                    getPackageRateProduct={this.props.getPackageRateProduct}
                    disabled={this.state.isViewMode}
                    getAllRoomTypesByHotel={this.props.getAllRoomTypesByHotel}
                    roomTypes={roomTypeState.roomTypeByHotel}
                  />
                </TabPane>
              </Tabs>
            </HMS.FormActionComponent>
          </HMS.PageListComponent>
        </HMS.LoadingComponent>
      </Fragment>
    );
  }
}
